import { useGateValue } from '@statsig/react-bindings';
import { useAiRecommendationData } from '@viome/viome-base/src/usecase/AiRecommendation/AiRecommendationQuery';
import { useUserDetails } from '@/hooks/useUserDetails';
import { isWrappedEligibleV2 } from '@/utils/isWrappedEligible';

export function useWrappedCardVisibility(): boolean {
  const userDetails = useUserDetails();
  // user_phi_id is on the runtime User payload but not yet in viome-base's
  // TypeScript model. See WrappedPageV2.tsx for the same cast.
  const userPhiId = (userDetails as unknown as { user_phi_id?: number })
    ?.user_phi_id;
  const { data: aiRecommendation } = useAiRecommendationData(userPhiId);
  const wrappedFlagEnabled = useGateValue('enable-viome-wrapped');
  return wrappedFlagEnabled && isWrappedEligibleV2(aiRecommendation);
}
